export default {
  Title: 'Client Metrics Dashboard',
  Subtitle: 'Financial forecast and actuals from the daily financial snapshot',
  VsPriorDay: 'vs. Prior day',
  VsPriorWeek: 'vs. Prior week',
  Daily: 'Daily',
  Weekly: 'Weekly',
  DatePickerLabel: 'Select snapshot date',
  GeneratedAt: 'Snapshot generated #{timestamp}',
  ComparisonDates: '#{currentDate} vs #{previousDate}',
  Previous: 'Prev: #{value}',
  Unavailable: '--',
  WeekOf: 'Week of #{date}',
  MarginPoints: '#{value} pts',
  Errors: {
    LoadError: 'Unable to load client metrics right now.',
  },
  EmptyStates: {
    MissingSnapshot: 'No financial snapshot is available for #{date}. It may not have been generated yet.',
    MissingComparisonSnapshot: 'No comparison snapshot is available for #{date}, so change indicators are hidden.',
    NoForecastWeeks: 'This snapshot contains no forecast weeks.',
    NoActualWeeks: 'This snapshot contains no completed actual weeks.',
  },
  ClientOverview: {
    SectionTitle: 'CLIENT OVERVIEW',
    ActiveClients: 'ACTIVE CLIENTS IN FORECAST',
    ActiveClientsCaption: 'Distinct clients with scheduled care in the 13-week forecast window',
    ScheduledClientsThisWeek: 'SCHEDULED CLIENTS THIS WEEK',
    ScheduledClientsThisWeekCaption: 'Clients with scheduled care in the current week',
    Caregivers: 'CAREGIVERS IN FORECAST',
    CaregiversCaption: 'Distinct caregivers assigned in the 13-week forecast window',
    MissingClientRates: 'VISITS MISSING CLIENT RATE',
    MissingClientRatesCaption: 'Scheduled visits without a billable client rate',
  },
  FinancialOverview: {
    SectionTitle: 'FINANCIAL OVERVIEW',
    ForecastTitle: '13-week forecast',
    ForecastSubtitle: '#{startDate} - #{endDate}',
    ActualTitle: 'Trailing 13 completed weeks',
    ActualSubtitle: 'Through week of #{date}',
    ScheduledHours: 'SCHEDULED HOURS',
    WeightedHours: 'HOLIDAY-WEIGHTED HOURS',
    ForecastRevenue: 'FORECAST REVENUE',
    ForecastLabor: 'FORECAST CAREGIVER LABOUR',
    ForecastGrossProfit: 'FORECAST GROSS PROFIT',
    ForecastGrossMargin: 'FORECAST GROSS MARGIN',
    ConfirmedHours: 'CONFIRMED HOURS',
    UnconfirmedHours: 'UNCONFIRMED HOURS',
    ActualRevenue: 'ACTUAL REVENUE',
    ActualLabor: 'ACTUAL CAREGIVER LABOUR',
    ActualGrossProfit: 'ACTUAL GROSS PROFIT',
    ActualGrossMargin: 'ACTUAL GROSS MARGIN',
  },
  Forecast: {
    SectionTitle: '13-WEEK FORECAST',
    FinancialTitle: 'Financial forecast by week',
    FinancialSubtitle: 'Weekly revenue, caregiver labour, and gross profit',
    CapacityTitle: 'Capacity forecast by week',
    CapacitySubtitle: 'Hours on the left axis; clients and caregivers on the right axis',
    Revenue: 'Revenue',
    Labor: 'Caregiver labour',
    GrossProfit: 'Gross profit',
    ScheduledHours: 'Scheduled hours',
    WeightedHours: 'Holiday-weighted hours',
    ScheduledClients: 'Scheduled clients',
    Caregivers: 'Caregivers',
  },
  Actuals: {
    SectionTitle: 'ACTUAL PERFORMANCE',
    HoursTitle: 'Scheduled vs. confirmed hours',
    HoursSubtitle: 'Trailing completed weeks',
    MoneyTitle: 'Scheduled vs. actual financials',
    MoneySubtitle: 'Trailing completed weeks',
    ScheduledHours: 'Scheduled hours',
    ConfirmedHours: 'Confirmed hours',
    ScheduledPayHours: 'Weighted scheduled hours',
    ConfirmedPayHours: 'Weighted confirmed hours',
    ScheduledRevenue: 'Scheduled revenue',
    ActualRevenue: 'Actual revenue',
    ScheduledLabor: 'Scheduled caregiver labour',
    ActualLabor: 'Actual caregiver labour',
    GrossProfit: 'Gross profit',
    HoursExplainer: 'Holiday-weighted hours count statutory-holiday shifts at 1.5x for pay and billing. Scheduled and confirmed hours count each hour once.',
  },
  WeeklyBreakdown: {
    SectionTitle: 'WEEKLY BREAKDOWN',
    ForecastTitle: 'Forecast weeks',
    ForecastSubtitle: 'Current week plus the next 12, earliest first',
    ActualTitle: 'Completed weeks',
    ActualSubtitle: 'Trailing 13 completed weeks, latest first',
    Week: 'Week',
    ScheduledClients: 'Clients',
    Caregivers: 'Caregivers',
    ScheduledHours: 'Sched. hours',
    WeightedHours: 'Weighted hours',
    ConfirmedHours: 'Conf. hours',
    Revenue: 'Revenue',
    ScheduledRevenue: 'Sched. revenue',
    ActualRevenue: 'Actual revenue',
    Labor: 'Labour',
    ActualLabor: 'Actual labour',
    GrossProfit: 'Gross profit',
    GrossMargin: 'Gross margin',
    ClientSlips: 'Client slips',
    CaregiverSlips: 'Caregiver slips',
    SlipCompletion: '#{complete} / #{total}',
  },
  ExpensesCompletion: {
    SectionTitle: 'EXPENSES & SLIP COMPLETION',
    Subtitle: 'Trailing 13 completed weeks. Expenses are pass-through amounts and are excluded from gross profit.',
    ClientExpenses: 'CLIENT EXPENSES',
    CaregiverExpenses: 'CAREGIVER EXPENSES',
    CompleteClientSlips: 'COMPLETE CLIENT SLIPS',
    IncompleteClientSlips: 'INCOMPLETE CLIENT SLIPS',
    CompleteCaregiverSlips: 'COMPLETE CAREGIVER SLIPS',
    IncompleteCaregiverSlips: 'INCOMPLETE CAREGIVER SLIPS',
  },
  DataQuality: {
    SectionTitle: 'DATA QUALITY',
    WarningAlert: 'This snapshot has data-quality warnings. Revenue or labour cost may be understated.',
    InfoAlert: 'This snapshot is missing one or more historical tracker weeks, so actual totals may be incomplete.',
    MissingActualWeeks: 'Missing actual tracker weeks',
    MissingActualWeekItem: 'Week of #{date}: missing #{trackers}',
    TrackerNames: {
      CLIENT: 'client tracker',
      CAREGIVER: 'caregiver tracker',
    },
    MissingClientRates: 'Missing client rates',
    MissingCaregiverRates: 'Missing caregiver rates',
    RateIssueValue: '#{count} occurrences, #{hours} hrs affected',
    UnassignedEvents: 'Unassigned scheduled events',
    SkippedEvents: 'Skipped schedule events',
    SkippedEventReasons: 'Skipped-event reasons',
    SkippedEventReasonItem: '#{reason}: #{count}',
  },
};
